// @flow
import React from "react";
import { Route, Switch } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router/immutable";

// Code-splitted imports
import Loadable from "react-loadable";
import ICPCLoader from "components/ICPCLoader";

const PublicApp = Loadable({
  loader: () => import("containers/PublicApp"),
  loading: ICPCLoader,
});
const PrivateApp = Loadable({
  loader: () => import("containers/PrivateApp"),
  loading: ICPCLoader,
});
const Login = Loadable({
  loader: () => import("routes/auth/Login"),
  loading: ICPCLoader,
});
const Register = Loadable({
  loader: () => import("routes/auth/Register"),
  loading: ICPCLoader,
});

function AppRoute(props: any) {
  const { history, authInitialized } = props;
  return (
    <ConnectedRouter history={history}>
      <Switch>
        {authInitialized && <Route path="/private" component={PrivateApp} />}
        <Route path="/login" render={(route) => <Login {...route} />} />
        <Route
          path="/register"
          render={(route) => <Register {...route} activate={false} />}
        />
        <Route
          path="/activate"
          render={(route) => <Register {...route} activate={true} />}
        />
        <Route path="/" component={PublicApp} />
      </Switch>
    </ConnectedRouter>
  );
}

export default AppRoute;
